import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import axios from "axios";

import { IoMdClose, IoMdHelpCircleOutline } from "react-icons/io";
import { IoCalendarOutline } from "react-icons/io5";
import { AiOutlineHome } from "react-icons/ai";
import { PiFolderOpenFill } from "react-icons/pi";
import { GoProjectRoadmap } from "react-icons/go";
import { HiOutlineOfficeBuilding } from "react-icons/hi";
import { LuMessagesSquare, LuPrinter, LuUser } from "react-icons/lu";
import { GrGroup } from "react-icons/gr";
import { RiGroupLine } from "react-icons/ri";
import { MdOutlineCreateNewFolder } from "react-icons/md";
import { FiMoon, FiSun } from "react-icons/fi";

import { GridSideMenuContainer } from "./styled/common";

function MenuList({ items, onClick }) {
  return (
    <ul>
      {items.map(({ title, icon: Icon, event, to }) => (
        <li key={title} onClick={() => onClick(event, to, title)}>
          <div className="icon">
            <Icon />
          </div>
          <span>{title}</span>
        </li>
      ))}
    </ul>
  );
}

export default function TooltipSideMenu({
  clickSideMenu,
  setClickSideMenu,
  setScreenMode,
  handlePrint,
}) {
  const user = useSelector((state) => state?.user?.data[0]);
  const isDarkMode = useSelector((state) => state?.scheduler?.isDarkMode);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const [isGroup, setIsGroup] = useState(false);
  const [isMaxWidth, setIsMaxWidth] = useState(false);

  useEffect(() => {
    setIsGroup(pathname.includes("group") && !pathname.includes("info"));
    setIsMaxWidth(
      pathname.includes("scheduler") ||
        pathname.includes("project") ||
        pathname.includes("filebox") ||
        (pathname.includes("mypage/search") && !pathname.includes("info")),
    );
  }, [pathname]);

  const baseMenu = [
    user && { title: "내 정보", icon: LuUser, to: "/mypage/modifyProfile" },
    { title: "캘린더", icon: IoCalendarOutline, to: "/mypage/scheduler" },
    { title: "프로젝트", icon: GoProjectRoadmap, to: "/mypage/projectList" },
    // { title: "e층창고", icon: AiOutlineHome, to: "/mypage/homepage" },
    { title: "모임", icon: GrGroup, to: "/group" },
    // { title: "업무", icon: HiOutlineOfficeBuilding, to: "/mypage/companies" },
    { title: "파일함", icon: PiFolderOpenFill, to: "/mypage/filebox" },
    user && { title: "1:1 문의", icon: IoMdHelpCircleOutline, to: "/help" },
  ].filter(Boolean);

  const groupMenu = [
    { title: "모임", icon: GrGroup, to: "/group" },
    { title: "피드", icon: LuMessagesSquare, to: "/group/feed" },
    { title: "내 모임", icon: RiGroupLine, to: "/group/my" },
    { title: "모임 생성", icon: MdOutlineCreateNewFolder, to: "/group/create" },
  ];

  const calendarMenu = [
    {
      title: isDarkMode ? "라이트모드" : "다크모드",
      icon: isDarkMode ? FiSun : FiMoon,
      event: () => setScreenMode(isDarkMode ? 0 : 1),
    },
    {
      title: "인쇄",
      icon: LuPrinter,
      event: handlePrint,
    },
  ];

  const handleClickMenu = (event, to, title) => {
    if (!isGroup && title === "모임" && !pathname.includes("group")) {
      window.open(`https://1472.ai/group`);
    } else if (event) {
      event();
    } else if (to) {
      navigate(to);
    }
    setClickSideMenu(false);
  };

  return (
    <GridSideMenuContainer
      className={clickSideMenu ? "open" : ""}
      onClick={(e) => e.target === e.currentTarget && setClickSideMenu(false)}>
      <div
        className="bg"
        onClick={(e) => e.target === e.currentTarget && setClickSideMenu(false)}
        style={{ maxWidth: isMaxWidth ? "100%" : undefined }}>
        <div className="menu">
          <div>
            <div className="arrow" />
            <div>
              <div className="logo">
                <img src="/img/logo.png" alt="Logo" />
                <span>바로가기</span>
              </div>
              <div className="close">
                <button onClick={() => setClickSideMenu(false)}>
                  <IoMdClose />
                </button>
              </div>
            </div>
            <div className="cont">
              {isGroup && <MenuList items={groupMenu} onClick={handleClickMenu} />}
              {pathname.includes("scheduler") && (
                <MenuList items={calendarMenu} onClick={handleClickMenu} />
              )}
              {(isMaxWidth || isGroup) && <div className="border"></div>}
              <MenuList items={baseMenu} onClick={handleClickMenu} />
            </div>
          </div>
        </div>
      </div>
    </GridSideMenuContainer>
  );
}
